export const styles = {
    screenLock: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        zIndex: 1500,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 8,
    },
    textWrapper: {
        flexDirection: "column",
        display: "flex",
        alignItems: "center",
        gap: 3,
        maxWidth: [60, 60, 75],
        width: "100%",
    },
    header: {
        textTransform: "uppercase",
    },
    subText: {
        whiteSpace: "pre-line",
        textAlign: "center",
    },
};
